class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-drawer').removeItem(this.dataset.index);
    });
  }
}

customElements.define('cart-drawer-remove-button', CartDrawerRemoveButton);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    if(this.querySelector('.cart-popup-background')) {
      this.querySelector('.cart-popup-background').addEventListener('click', this.close.bind(this));
    }
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this)),
    );

    this.form = this.querySelector('form');
    if (this.form) {
      const cartSubmitInput = document.createElement('input');
      cartSubmitInput.setAttribute('name', 'checkout');
      cartSubmitInput.setAttribute('type', 'hidden');

      this.form.appendChild(cartSubmitInput);
    }

    this.checkoutDrawer = this.querySelector('#checkout-drawer');
    if (this.checkoutDrawer) {
      this.checkoutDrawer.addEventListener('click', () => {
        this.form.submit();
      });
    }
  }

  removeItem(line) {
    const body = JSON.stringify({
      line,
      quantity: 0,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body,
    })
      .then((res) => res.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.renderContents(parsedState, false);
      })
      .catch(() => {});
  }

  open() {
    this.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  renderContents(parsedState, open = true) {
    this.getSectionsToRender().forEach((section) => {
      section.selectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((target) => {
          let html = '';
          if (parsedState && parsedState.sections && parsedState.sections[section.id]) {
            html = parsedState.sections[section.id];
          }

          target.innerHTML = this.getSectionInnerHTML(html, selector);
        });
      });
    });

    if (open) this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selectors: ['.cart-popup-list'],
      },
      {
        id: 'cart-icon-bubble',
        selectors: ['.cart-icon-with-counter'],
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    if (!html) return '';

    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');

    const section = parsedHtml.querySelector(selector);
    if (!section) return '';

    return section.innerHTML;
  }
}

customElements.define('cart-drawer', CartDrawer);

const cartDrawerCheckoutBtn = document.querySelector('.cart-popup-list .button-checkout');
if (cartDrawerCheckoutBtn) {
  cartDrawerCheckoutBtn.addEventListener('click', () => {
    window.lintrk('track', {conversion_id: 12984593});
  });
}
